<template>
  <div class="center-order">
    <div class="order-box">
      <ul class="fl order-nav">
        <li
                v-for="(item,index) in orderNav"
                :key="index"
                :class="{'active':item.status==currentStatus}" @click="getCurrentOrderList(item.status)">{{item.name}}</li>
      </ul>
      <!--<div class="fr order-query">
        <el-input placeholder="请输入订单关键字" v-model="orderKey">
          <el-button slot="append">搜索订单</el-button>
        </el-input>
      </div>-->
    </div>
    <order-item @change="getAllOrderList()" :orderList="orderList" :nowTime="nowTime" v-if="nowTime!==''"></order-item>
    <el-pagination
            @current-change="handleCurrentChange"
            :current-page="current"
            layout=" prev, pager, next,total, jumper"
            style="text-align: center;padding:20px;"
            :hide-on-single-page="isTotalOnePage"
            :total="total">
    </el-pagination>
  </div>
</template>
<script>
  import OrderItem from '../../components/order/orderItem'
  import {allOrder} from '../../api/order'
  export default {
      data(){
          return {
              userInfo:JSON.parse(localStorage.getItem('user'))||null,
              activeOrder: 'allOrder',
              pendingOrder:1,
              backOrder:1,
              receiveOrder:1,
              current:1,
              size:10,
              total:0,
              currentStatus:-1,//-1全部 0待支付 1代发货 2代签收 3待评价 4已完成
              orderKey:'',//订单关键字
              orderNav:[
                  {
                      name:'全部',
                      status:-1
                  },
                  {
                      name:'待支付',
                      status:0
                  },
                  {
                      name:'待发货',
                      status:1
                  },
                  {
                      name:'待收货',
                      status:2
                  },
                  {
                      name:'待评价',
                      status:3
                  },
                  {
                      name:'已完成',
                      status:4
                  },
                  /*{
                      name:'线下订单',
                      status:9
                  },*/
                  {
                      name:'售后',
                      status:5
                  },
                  {
                      name:'已失效',
                      status:6
                  }
              ],
              nowTime:'',
              orderList:[],
              isTotalOnePage:false,
          }
      },
      components:{
          OrderItem
      },
      created () {
          this.getAllOrderList();
      },
      methods:{
          handleCurrentChange(current){
              this.current=current;
              this.getAllOrderList();
          },
          getCurrentOrderList(status){
              if(this.currentStatus!==status){
                  this.current=1;
                  this.currentStatus=status;
                  this.getAllOrderList();
              }

          },
          getAllOrderList(){
              let param={
                  current:this.current,
                  size:this.size,
                  status:this.currentStatus
              };
              if(this.currentStatus==-1){
                  delete param.status;
              }
              if(this.currentStatus==9){
                  delete param.status;
                  param.payType=5;
              }
              allOrder(param).then(res=>{
                  this.total=res.data.total;
                  this.isTotalOnePage=this.total<this.size?true:false;
                  this.nowTime=res.nowTime;
                  this.orderList=res.data.records;
              })
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/common";

  .center-order{
    padding:30px 40px 50px;background-color:#ffffff;
    .order-box{
      overflow: hidden;
      padding-bottom:26px;
      .order-nav{
        overflow: hidden;
        li{
          @include hover-color;
          float: left;font-size:16px;color:#333;
          margin-right:47px;
          height:40px;
          &.active{
            color:$main-color;
            font-size:19px;
            position: relative;
            &:after{
              content: '';
              position: absolute;
              bottom:6px;
              left:0;
              width:100%;
              height:3px;
              background-color:$main-color;
              -webkit-border-radius: 2px;
              -moz-border-radius: 2px;
              border-radius: 2px;
            }
          }
        }
      }
    }


  }
</style>
<style lang="scss">
  @import "../../assets/css/common";
  .order-query{
    width:230px;height:30px;
    border:1px solid #E0E0E0;
    .el-input__inner{
      font-size:12px;
      height:30px;
      line-height:30px;border:none;}
    .el-input-group__append, .el-input-group__prepend{
      font-size:12px;
      background-color:#F5F5F5;
      width:46px;
      padding:0 10px;
      border:none;
      color:#333;
      -webkit-border-radius: 0px;
      -moz-border-radius: 0px;
      border-radius: 0px;
    }
  }
</style>

